// extracted by mini-css-extract-plugin
export var container = "_qx-0";
export var dotAnimation = "_qx-2";
export var dotsLoading = "_qx-1";